// import './bootstrap.js';
import Vue3EasyDataTable from "vue3-easy-data-table"; // DATATABLE
import "vue3-easy-data-table/dist/style.css"; // DATATABLE
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import LaravelPermissionToVueJS from "laravel-permission-to-vuejs"; // PERMISSIONS
import Maska from "maska";
import VueExcelEditor from 'vue3-excel-editor'

//////////////////////////////////////////////////////////// Font Awesome
/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
/* import font awesome icon component */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
/* import specific icons */
import {faUser, faKey, faGear, faClockRotateLeft, faPlus, faTrash, faCircleInfo, faSquareCheck, faSquareXmark, faBars, faPlay, faBackwardStep, faForwardStep, faX} from "@fortawesome/free-solid-svg-icons";
/* add icons to the library */
library.add(
    faUser,
    faKey,
    faGear,
    faClockRotateLeft,
    faPlus,
    faTrash,
    faCircleInfo,
    faSquareCheck,
    faSquareXmark,
    faBars,
    faPlay,
    faBackwardStep,
    faForwardStep,
    faX
);

//////////////////////////////////////////////////////////// Layouts
import AuthLayout from "./Layouts/AuthLayout.vue";

//////////////////////////////////////////////////////////// Datepicker
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
//////////////////////////////////////////////////////////// QR Scanner
import { StreamBarcodeReader } from "vue-barcode-reader";
//////////////////////////////////////////////////////////// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, fa } from "vuetify/iconsets/fa";
import { mdi } from "vuetify/iconsets/mdi";

////////////////////////////////////////////Ant Design Vue
import Antd from "ant-design-vue";

//DO NOT IMPORT THIS CSS GLOBALLY !!!!!!
//import "ant-design-vue/dist/antd.css";

//////////////////////////////////////////// Pinia
import { createPinia } from 'pinia'
const pinia = createPinia()

import { VueSignaturePad } from "vue-signature-pad";

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: "fa",
        aliases,
        sets: {
            fa,
            mdi,
        },
    },
    theme: {
        defaultTheme: "D3Theme",
        themes: {
            light: {
                background: "#f0f2f5", // Set the background color for all Vuetify components
            },
            D3Theme: {
                colors: {
                    primary: "#242939",
                    info: "#1e92a6",
                    danger: "#EF5350",
                    secondary: "#03DAC6",
                    close: "#6c757d",
                },

            },
        },
    },
});

createInertiaApp({
    resolve: (name) => {
        const page = require(`./Pages/${name}`).default;
        page.layout = page.layout || AuthLayout;
        return page;
    },
    // resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(vuetify)
            .use(Antd)
            .use(LaravelPermissionToVueJS)
            .use(Maska)
            .use(pinia)
            .use(VueExcelEditor)
            .component("EasyDataTable", Vue3EasyDataTable)
            .component("font-awesome-icon", FontAwesomeIcon)
            .component("Datepicker", Datepicker)
            .component("StreamBarcodeReader", StreamBarcodeReader)
            .component("VueSignaturePad", VueSignaturePad)
            .mixin({ methods: { route } })
            .mount(el);
    },
});
